import React, { useEffect, useState } from "react";

const StoryProgressBar = ({ className, totalPages, currentPage, duration }) => {
  return (
    <div className={className} style={styles.container}>
      {Array.from({ length: totalPages }).map((_, index) => (
        <div
          key={index}
          style={{
            ...styles.segment,
            backgroundColor:
              index < currentPage
                ? "white" // Completed pages
                : "grey", // Pending pages
          }}
        >
          {index === currentPage && (
            <div
              style={{
                ...styles.activeProgress,
                animation: `${duration}s 1 linear progress forwards`,
              }}
            />
          )}
        </div>
      ))}
      <style>
        {`
          @keyframes progress {
            from {
              width: 0%;
            }
            to {
              width: 100%;
            }
          }
        `}
      </style>
    </div>
  );
};

export default StoryProgressBar;

const styles = {
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "calc(100% - 32px)",
    height: "5px",
    margin: "16px 16px 0px 16px",
    gap: "5px",
  },
  segment: {
    flex: 1,
    height: "3px",
    position: "relative",
    backgroundColor: "grey",
    borderRadius: "2.5px",
    overflow: "hidden",
  },
  activeProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    backgroundColor: "white",
    animationFillMode: "forwards",
  },
};
